// extracted by mini-css-extract-plugin
export default {"menuBlock":"YE-z","title":"ZE-z","nav":"_E-z","flexCell":"aF-z","facetLink":"bF-z"};